import { Box, Stack } from '@mui/material';

export type ApprovalSlotState = 'approved' | 'pending' | 'denied';

export const ApprovalDots = ({ slots }: { slots: ApprovalSlotState[] }) => (
  <Stack
    direction='row'
    sx={{
      gap: '4px',
      alignItems: 'center',
    }}
  >
    {slots.map((state, i) => {
      const color =
        state === 'approved'
          ? 'var(--mui-palette-success-main)'
          : state === 'denied'
            ? 'var(--mui-palette-error-main)'
            : 'var(--mui-palette-divider)';
      return <ApprovalDot key={i} color={color} />;
    })}
  </Stack>
);

export const ApprovalDot = ({ color }: { color: string }) => (
  <Box
    sx={{
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: color,
    }}
  />
);
